export const GET_DELETE_CONFIRMATION_TEXT = (respondentName: string) => `Are you sure you would like to delete this response from ${respondentName}?`;

export const DELETE_TEXT = "Delete";
export const CANCEL_TEXT = "Cancel";


// WEBPACK FOOTER //
// ./src/pages/director/evaluation/constants.ts